import {
  FETCH_BOOKING_DISCOUNT,
  FETCH_BOOKING__DISCOUNT_SUCCESS,
  FETCH_BOOKING__DISCOUNT_FAILED,
} from "../store/types";
import { getSupabase } from '../config/configureSupabase';
import store from '../store/store';

export const fetchEarningsReport = () => async (dispatch) => {
  dispatch({
    type: FETCH_BOOKING_DISCOUNT,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const userInfo = store.getState().auth?.profile;
      let query = supabase.from('routes').select('*').in('status', ['PAID', 'COMPLETE', 'CANCELLED']);
      if (userInfo?.tenant_id) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }

      const { data, error } = await query;
      if (!error && data) {
        const monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const renderobj = {};

        data.forEach(r => {
          const bdt = new Date(r.created_at || Date.now());
          const uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth();
          const distKm = Number(r.total_distance_km || 10);
          const tripCost = distKm * 3;
          const driverShare = distKm * 2;
          const customerPaid = tripCost;

          if (renderobj[uniqueKey]) {
            renderobj[uniqueKey].driverShare = (parseFloat(renderobj[uniqueKey].driverShare) + driverShare).toFixed(2);
            renderobj[uniqueKey].customerPaid = (parseFloat(renderobj[uniqueKey].customerPaid) + customerPaid).toFixed(2);
            renderobj[uniqueKey].tripCost = (parseFloat(renderobj[uniqueKey].tripCost) + tripCost).toFixed(2);
            renderobj[uniqueKey].myEarning = (parseFloat(renderobj[uniqueKey].customerPaid) - parseFloat(renderobj[uniqueKey].driverShare)).toFixed(2);
            renderobj[uniqueKey].total_rides += 1;
          } else {
            renderobj[uniqueKey] = {
              dated: r.created_at,
              year: bdt.getFullYear(),
              month: bdt.getMonth(),
              monthsName: monthsName[bdt.getMonth()],
              uniqueKey: uniqueKey,
              total_rides: 1,
              discountAmount: "0.00",
              driverShare: driverShare.toFixed(2),
              customerPaid: customerPaid.toFixed(2),
              convenienceFee: "0.00",
              tripCost: tripCost.toFixed(2),
              cancellationFee: "0.00",
              myEarning: (customerPaid - driverShare).toFixed(2),
              rideCost: tripCost.toFixed(2)
            };
          }
        });

        dispatch({
          type: FETCH_BOOKING__DISCOUNT_SUCCESS,
          payload: Object.values(renderobj)
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_BOOKING__DISCOUNT_SUCCESS,
    payload: []
  });
};
